<!-- 转为订单 -->
<template>
    <div id="">
        <el-form :model="formData" :rules="rules" :inline="true" ref="formData" label-width="80px">
            <div class="UName">
                {{tableData.UName}}
            </div>
            <el-table
                    :data="tableData.DetailList"
                    border
                    style="width: 100%">
                <el-table-column
                        width="190px"
                        prop="GoodCode"
                        label="商品编码">
                </el-table-column>
                <el-table-column
                        prop="GoodName"
                        label="商品名称">
                </el-table-column>
                <el-table-column
                        prop="GoodName"
                        label="英文名称">
                </el-table-column>
                <el-table-column
                        prop="BrandName"
                        label="品牌">
                </el-table-column>

                <el-table-column
                        width="50px"
                        prop="Size"
                        label="尺寸">
                </el-table-column>
                <el-table-column
                        width="50px"
                        prop="Quality"
                        label="重量">
                </el-table-column>
                <el-table-column
                        width="50px"
                        prop="Unit"
                        label="单位">
                </el-table-column>
                <el-table-column
                        width="80px"
                        prop="minPrice"
                        label="起售价">
                </el-table-column>
                <el-table-column
                        width="100px"
                        prop="SellPrice"
                        label="售价">
                    <template slot-scope="scope">
                        <el-input
                                v-model.trim="scope.row.SellPrice"
                                :min="scope.row.minPrice"
                                size="mini" type="number"
                                @blur="checkPrice(scope.row.SellPrice,scope.$index)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        width="150px"
                        label="数量">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.Count" :min="scope.row.MinOrderCount" size="mini"></el-input-number>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
                <el-form-item label="发货方式" prop="ShipType">
                    <el-select v-model="formData.ShipType" placeholder="请选择" @change="ShipTypeChange(formData.ShipType)">
                        <el-option
                                v-for="item in tableData.DeliveryMethodList"
                                :key="item.TKey"
                                :label="item.TValue"
                                :value="item.TKey">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="支付方式" prop="PayType">
                    <el-select v-model="formData.PayType" placeholder="请选择" @change="PayTypeChange(formData.PayType)">
                        <el-option
                                v-for="item in tableData.PaymentMethodList"
                                :key="item.TKey"
                                :label="item.TValue"
                                :value="item.TKey">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div>
                <el-form-item label="收货地址" prop="AddressId">
                    <el-select v-model="formData.AddressId" placeholder="请选择" style="width: 524px">
                        <el-option
                                v-for="item in tableData.AddressList"
                                :key="item.AddrId"
                                :label="item.AddrName"
                                :value="item.AddrId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div>
                <el-form-item label="备注">
                    <el-input
                            style="width: 830px;"
                            :autosize="{ minRows:3}"
                            type="textarea"
                            placeholder="请输入内容"
                            v-model.trim="formData.Remark">
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div class="dialog-footer">
            <el-button type="primary" @click="submitForm">转为订单</el-button>
            <el-button @click="close()">取消</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        props:{
            InquiryId:String,
        },
        components: {

        },
        data(){
            return {
                tableData:{},
                formData:{
                    IBId:'',
                    DiscountAmount:0,
                    PayType:'',
                    PayTypeName:'',
                    ShipType:'',
                    ShipTypeName:'',
                    Remark:'',
                    OperatorId:this.$util.getSessionStorage('userMsg').Id,
                    Operator:this.$util.getSessionStorage('userMsg').Name,
                    AddressId:'',
                    DetailList:[]
                },
                rules: {
                    ShipType: [
                        {required: true, message: '该项必填', trigger: 'change'},
                    ],
                    AddressId: [
                        {required: true, message: '该项必填', trigger: 'change'},
                    ],
                    PayType: [
                        {required: true, message: '该项必填', trigger: 'change'},
                    ],
                },
            }
        },
        mounted(){
            this.getData()
        },
        watch:{
            InquiryId(){
                this.getData()
            }
        },
        methods:{
            // 关闭弹窗
            clearVal(){
                this.$refs.formData.clearValidate();
            },
            checkPrice(value,index){
                let data = this.tableData.DetailList
                if (value < data[index].minPrice){
                    data[index].SellPrice = data[index].minPrice
                    this.$util.warningMsg('商品价格不能低于报价')
                }
            },
            ShipTypeChange(value){
                let _data = this.tableData.DeliveryMethodList
                for (let i = 0;i<_data.length;i++){
                    if(_data[i].TKey == value){
                        this.formData.ShipTypeName = _data[i].TValue
                        return
                    }
                }
            },
            PayTypeChange(value){
                let _data = this.tableData.PaymentMethodList
                for (let i = 0;i<_data.length;i++){
                    if(_data[i].TKey == value){
                        this.formData.PayTypeName = _data[i].TValue
                        return
                    }
                }
            },
            getData(){
                this.axios.get('/Inquiry/GetQuotationOrder',{
                    params: {
                        IBId:this.InquiryId
                    }

                })
                    .then((response)=> {
                        let data = response.data.data[0]
                        for (let i=0;i<data.DetailList.length;i++){
                            data.DetailList[i].minPrice = data.DetailList[i].SellPrice
                        }
                        this.tableData = data
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            close(){
                this.$emit('closeDialog')
            },
            resetForm(){
                this.$refs.formData.clearValidate();
            },
            submitForm(){
                this.$refs.formData.validate((valid) => {
                    if (valid) {
                        let _data = this.tableData.DetailList
                        for (let i = 0;i<_data.length;i++){
                            if ( !Number(_data[i].SellPrice) || Number(_data[i].SellPrice) < _data[i].minPrice){
                                this.$util.warningMsg('售价不可以小于报价')
                                return
                            }
                        }
                        for (let i = 0;i<_data.length;i++){
                            _data[i].price = _data[i].SellPrice
                        }
                        this.formData.IBId = this.InquiryId
                        this.formData.DetailList = _data
                        this.axios.post('/Inquiry/TransformQuotationOrder', this.formData)
                            .then((response) => {
                                this.$util.successMsg('转为订单成功')
                                this.$emit('closeDialog')
                            })
                            .catch((error) => {
                                console.log(error);
                                this.$message.error('转为订单失败！');
                            });
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
    .UName {
        line-height: 36px;
        text-align: center;
        font-size: 24px;
        padding-bottom: 20px;
    }
    .dialog-footer {
        text-align: right;
        margin-right: 20px;
        padding-top: 20px;
    }
    .prv-ctn {
        display: flex;
        padding-top: 10px;
    }
</style>
